<script>
import { getCustomerBreakdown } from "./reporting-mock-data";
import toCurrency from "@/helpers/currency";

export default {
  name: "reporting-pie-chart",
  props: {
    periodType: {
      type: String,
      default: "month",
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      customerData: [],
      chartOptions: {
        chart: {
          type: "donut",
          height: 350,
        },
        labels: [],
        colors: [
          "#556ee6",
          "#34c38f",
          "#f46a6a",
          "#50a5f1",
          "#f1b44c",
          "#9c27b0",
          "#ff9800",
          "#795548",
        ],
        legend: {
          position: "bottom",
          horizontalAlign: "center",
          fontSize: "13px",
          markers: {
            width: 10,
            height: 10,
            radius: 2,
          },
          itemMargin: {
            horizontal: 8,
            vertical: 4,
          },
        },
        plotOptions: {
          pie: {
            donut: {
              size: "70%",
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: "14px",
                  fontWeight: 600,
                  offsetY: -10,
                },
                value: {
                  show: true,
                  fontSize: "20px",
                  fontWeight: 700,
                  offsetY: 5,
                  formatter: (val) => toCurrency(val),
                },
                total: {
                  show: true,
                  label: "Total Revenue",
                  fontSize: "14px",
                  fontWeight: 600,
                  color: "#6c757d",
                  formatter: (w) => {
                    const total = w.globals.seriesTotals.reduce(
                      (a, b) => a + b,
                      0
                    );
                    return toCurrency(total);
                  },
                },
              },
            },
          },
        },
        dataLabels: {
          enabled: true,
          formatter: (val) => val.toFixed(1) + "%",
          style: {
            fontSize: "12px",
            fontWeight: 600,
          },
          dropShadow: {
            enabled: false,
          },
        },
        tooltip: {
          y: {
            formatter: (value) => toCurrency(value),
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 300,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },
      series: [],
    };
  },
  watch: {
    periodType: {
      handler: "loadData",
      immediate: true,
    },
  },
  methods: {
    loadData() {
      // Simulate API call with mock data
      this.customerData = getCustomerBreakdown(this.periodType);
      this.updateChart();
    },
    updateChart() {
      // Sort by revenue and take top 8
      const topCustomers = this.customerData
        .sort((a, b) => b.revenue - a.revenue)
        .slice(0, 8);

      // Prepare labels (customer names)
      const labels = topCustomers.map((item) => item.customerName);

      // Prepare series data
      const revenueData = topCustomers.map(
        (item) => Math.round(item.revenue * 100) / 100
      );

      // Update chart
      this.chartOptions = {
        ...this.chartOptions,
        labels: labels,
      };

      this.series = revenueData;
    },
  },
};
</script>

<template>
  <b-card no-body>
    <b-card-body>
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h4 class="card-title mb-0">Revenue Share by Customer</h4>
        <div>
          <i class="bx bx-pie-chart-alt-2 text-warning font-size-20"></i>
        </div>
      </div>

      <div v-if="isLoading" class="text-center py-5">
        <b-spinner variant="warning" label="Loading..."></b-spinner>
        <p class="text-muted mt-2">Loading chart data...</p>
      </div>

      <div v-else>
        <apexchart
          type="donut"
          height="350"
          :options="chartOptions"
          :series="series"
        ></apexchart>
      </div>
    </b-card-body>
  </b-card>
</template>

<style scoped>
.card-title {
  font-size: 1.1rem;
  font-weight: 600;
}
</style>
